import UserActivity from '../UserActivity.vue'

export default [
    {
        path: '/user-activity',
        name: '/user-activity',
        meta: { layout: 'mystagit' },
        component: UserActivity,
    },
]